<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-9 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Profile</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-row">
                                <div class="col-md-4 col-12 mb-3">
                                    <label>Nom</label>
                                    <input type="text" class="form-control" />
                                </div>
                                <div class="col-md-4 col-12 mb-3">
                                    <label>Prenom(s)</label>
                                    <input type="text" class="form-control"/>
                                </div>
                                <div class="col-md-4 col-12 mb-3">
                                    <label>Email</label>
                                    <input type="text" class="form-control" />
                                </div>
                            </div>
                            <button class="btn btn-primary" type="submit"> Sauvegarder les modifications </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "profile"
    }
</script>

<style scoped>

</style>
